/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Smart Home API
 * A smart home management system providing REST APIs for device integrations and automation
 * OpenAPI spec version: 1.0
 */

export type DevicesDeviceType = (typeof DevicesDeviceType)[keyof typeof DevicesDeviceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DevicesDeviceType = {
  DeviceTypeSwitch: 'switch',
  DeviceTypeLight: 'light',
  DeviceTypeWindowCovering: 'window_covering',
  DeviceTypeFan: 'fan',
  DeviceTypeSpeaker: 'speaker',
  DeviceTypeTV: 'tv',
} as const;
